export const ARBITRUM_TESTNET_TOKEN_LIST = {
  name: 'KyberSwap Token List',
  keywords: ['dmmexchange', 'kyberswap'],
  timestamp: '2020-02-08T00:00:00+00:00',
  tokens: [
    {
      chainId: 421611,
      address: '0xB4BbD0250618917b3679578C58f6440A227C8c03',
      symbol: 'USDC',
      name: 'USDC',
      decimals: 6,
    },
    {
      chainId: 421611,
      address: '0x41a56c30b881296859FB4db30Eb9a639B473619B',
      symbol: 'USDT',
      name: 'USDT',
      decimals: 6,
    },
    {
      chainId: 421611,
      address: '0x340eefA7154BF23e328F59E936568607841FE027',
      symbol: 'DAI',
      name: 'DAI',
      decimals: 18,
    },
    {
      chainId: 421611,
      address: '0xB47e6A5f8b33b3F17603C83a0535A9dcD7E32681',
      symbol: 'WETH',
      name: 'Wrapped Ether',
      decimals: 18,
    },
    {
      chainId: 421611,
      address: '0x7596961744096D12eFa3CfA58d1D30EDd82BD396',
      symbol: 'KNC',
      name: 'KNC',
      decimals: 18,
    },
  ],
  version: {
    major: 0,
    minor: 0,
    patch: 0,
  },
}
